import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
export function AppLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);
  return <div className="flex h-screen w-full overflow-hidden bg-background text-foreground" data-id="element-34" data-mp="1mh370im9c56g">
      <Sidebar mobileOpen={menuOpen} onClose={() => setMenuOpen(false)} data-id="element-35" data-mp="1ihaw3z9e5mxx" />
      <div className="flex min-w-0 flex-1 flex-col" data-id="element-36" data-mp="1dorfetfeqbow">
        <Header onMenuClick={() => setMenuOpen(true)} data-id="element-37" data-mp="1dn6nzcoe38v9" />
        <main className="flex-1 overflow-y-auto p-3 sm:p-4 md:p-6" data-id="element-38" data-mp="18qznw0iocrl8">
          <Outlet data-id="element-39" data-mp="13r3j3z25kw4m" />
        </main>
      </div>
    </div>;
}